import type {
	LogoUmbBlockElementModel,
	LogoUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import { Logo } from "#/_packages/umbrella/features/logo/components/logo";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import {
	toHoverItemCssClasses,
	toHoverMediaCssClasses,
} from "#/_packages/umbrella/integrations/umbraco/utils/animation-utils.ts";
import { convertToCroppedFocalPointUrl } from "#/_packages/umbrella/integrations/umbraco/utils/image-utils.ts";
import { tryGetAnimationScrollType } from "#/_packages/umbrella/utils";
import {
	getAltText,
	getAltTextFromString,
} from "#/_packages/umbrella/utils/image-utils.ts";

type LogoBlockProps = BlockItemProps & {
	content: LogoUmbBlockElementModel;
	settings: LogoUmbBlockSettingsElementModel;
};

export default function LogoUmbBlock({ className, settings }: LogoBlockProps) {
	const siteSettings = useGetSiteSettings();

	if (!siteSettings) return null;

	const logoMedia = siteSettings.headerLogo?.[0];
	const logoText = siteSettings.headerLogoText ?? "";
	const imageSrc = logoMedia
		? convertToCroppedFocalPointUrl(logoMedia)
		: undefined;
	const imageAlt = getAltTextFromString(logoText) || getAltText(logoMedia);
	const animationHoverType = settings.properties?.animationHoverType;

	return (
		<Logo
			className={className}
			href="/"
			imageSrc={imageSrc}
			imageAlt={imageAlt}
			ariaLabel={siteSettings.headerLogoAriaLabel ?? undefined}
			text={logoText}
			animationScrollType={tryGetAnimationScrollType(
				settings.properties?.animationScrollType,
			)}
			hoverItemClasses={toHoverItemCssClasses(animationHoverType)}
			hoverMediaClasses={toHoverMediaCssClasses(animationHoverType)}
		/>
	);
}
